// extracted by mini-css-extract-plugin
export default {"eledoPdfToolbar":"TopToolbar_eledoPdfToolbar__aaykF","toolbarGroup":"TopToolbar_toolbarGroup__QKEjl"};